import TableRenderClass from '@C/tableRender/tableRenderClass';
import { invoice } from '@/api/ajax';
import Vue from 'vue';
import createExtend from '@C/createExtend';
import invoiceOpenListUserInfo from './ApplyForCommissionUsers';
import { moneyFixed } from '@/tools/money';
import { bankRowLabelFiled, bankSearchFiled } from '@/common/fields/bank';
import { PAY_BANK_TYPE_KEY } from '@/common/constants/bank';

const defineReactive = Vue.util.defineReactive;
const fields = {
  selection: {
    type: 'selection',
    width: '50px',
    prop: 'csoCustomOrderId',
    reserve: true,
    selectable: row => {
      return row.$selectedPerson && row.$selectedPerson.length > 0;
    }
  },
  index: {
    width: '60px',
    label: '序号',
    type: 'index'
  },
  // csoCustomOrderId: {
  //   label: '总订单id',
  //   prop: 'csoCustomOrderId'
  // },
  orderNo: {
    label: '订单编号',
    prop: 'orderNo'
  },
  invoiceOrderType: {
    label: '订单类型',
    prop: 'invoiceOrderType',
    render: h => h('span', '项目订单')
  },
  ...bankRowLabelFiled,
  __selectedPerson: {
    label: '已选人数',
    // headerRender:(h,ctx,r,c)=>{
    //   return h('div',['已选人数',h('i',{
    //     class:'el-icon-question',
    //     style:{
    //       marginLeft:'5px',
    //       cursor:'pointer'
    //     }
    //   })])
    // },
    render: (h, ctx, r, c) => {
      // 保存 已选开票人
      defineReactive(r, '$selectedPerson', []);
      return h(
        'el-button',
        {
          props: {
            type: 'text'
          },
          on: {
            click: e => {
              const userInfo = createExtend(invoiceOpenListUserInfo, {
                selection: r['$selectedPerson'],
                csoCustomOrderId: r.csoCustomOrderId
              });

              userInfo.$on('submit', selection => {
                const cpSelection = JSON.parse(JSON.stringify(selection));
                r['$selectedPerson'] = cpSelection;
                // 设置全局数据，用于初始数据重新赋值
                ctx.injections.indexPage.selectedPersonForOrderNo[
                  r.orderNo
                ] = cpSelection;
                let priceList = selection.map(i => i.projectPrice);
                r['$clientCountPrice'] =
                  priceList.length && priceList.reduce((a, b) => a + b);
              });
            }
          }
        },
        `${r['$selectedPerson'].length}/${r['applicationStatus']}`
      );
    }
  },
  __clientCountPrice: {
    label: '已选开票金额',
    render: (h, ctx, r, c) => {
      defineReactive(r, '$clientCountPrice', 0);
      return h('span', moneyFixed(r['$clientCountPrice']));
    }
  },
  applicationStatus: {
    label: '人数总数',
    prop: 'applicationStatus'
  },
  projectPrice: {
    label: '可开票金额',
    prop: 'projectPrice',
    formatter: (r, ctx, v) => moneyFixed(v)
  }
  // createDt: {
  //   label: '订单创建时间',
  //   prop: 'createDt'
  // }
};

//初始化
export let example = new TableRenderClass({ fields });

/*主页面入口*/
export const main = [
  {
    name: '结算订单|列表',
    childMenu: [
      example.createPart({
        name: '结算订单|列表',
        search: [bankSearchFiled],
        list: invoice.invoiceOpenListToBeOpened,
        requestNow: true,
        defaultQuery: {},
        fields: [
          'selection',
          'index',
          'orderNo',
          PAY_BANK_TYPE_KEY,
          'invoiceOrderType',
          '__selectedPerson',
          'projectPrice',
          '__clientCountPrice'
        ],
        moreBtnArr: []
      })
    ]
  }
];

// import TableRenderClass from '@C/tableRender/tableRenderClass';
// import { invoice } from '@/api/ajax';
// import Vue from 'vue';
// import { COLLECT_MONEY_TYPE, INVOICE_STATUS } from '@/api/searchTypes';
// import { moneyFixed } from '@/tools/money';
// const defineReactive = Vue.util.defineReactive;
// const fields = {
//   selection: {
//     type: 'selection',
//     width: '50px',
//     prop: 'taxationId',
//     reserve:true,
//     selectable:row=>{
//       return +row.invoiceStatus===0
//     }
//   },
//   index: {
//     width: '60px',
//     label: '序号',
//     type: 'index'
//   },
//   // taxationId: {
//   //   label: '唯一',
//   //   prop: 'taxationId'//  唯一
//   // },
//   fullName: {
//     label: '项目参与人姓名',
//     prop: 'fullName'//   项目参与人
//   },
//   userPhone: {
//     label: '手机号',
//     prop: 'userPhone'//  用户手机号
//   },
//   collectMoneyType: {
//     label: '收款方式',
//     prop: 'collectMoneyType',//  C端收款方式  1 银行卡  2 钱包
//     formatter:(r,ctx,v)=>{
//       return COLLECT_MONEY_TYPE.get(+v)
//     }
//   },
//   bfAccount: {
//     label: '收款账号',
//     prop: 'bfAccount'// 收款账号
//   },
//   projectPrice: {
//     label: '终端结算金额',
//     prop: 'projectPrice',//  终端结算金额
//     formatter:(r,ctx,v)=> moneyFixed(v)
//   },
//   invoiceStatus: {
//     label: '开票状态',
//     prop: 'invoiceStatus', //   0 未开票  1 已申请  2 已完成
//     formatter:(r,ctx,v)=>{
//       return INVOICE_STATUS.get(v)
//     }
//   }
// };
//
// //初始化
// export let example = new TableRenderClass({ fields });
//
// /*主页面入口*/
// export const main = [
//   {
//     name: '用户|列表',
//     childMenu: [
//       example.createPart({
//         name: '用户|列表',
//         search: [],
//         list: invoice.invoiceOpenListUserInfo,
//         requestNow: true,
//         defaultQuery: {},
//         fields: [
//           'selection',
//           'taxationId',
//           'index',
//           'fullName',
//           'userPhone',
//           'collectMoneyType',
//           'bfAccount',
//           'projectPrice',
//           'invoiceStatus'
//         ],
//         moreBtnArr: []
//       })
//     ]
//   }
// ];
//
